import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { CompanyReportsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

export type CompanyReport = NonNullable<CompanyReportsQuery["companyReports"]>["reports"][number];

const COMPANY_REPORTS_QUERY = graphql(`
  query companyReports($companyGuid: String!) {
    companyReports(companyGuid: $companyGuid) {
      reports {
        id
        title
        description
        publishedAt
        reportType
        pdfUrl
      }
    }
  }
`);

export function useCompanyReports(
  companyGuid: string,
  options?: UseQueryOptions<CompanyReportsQuery, unknown, CompanyReportsQuery, QueryKey>,
) {
  const result = useGraphQlQuery(
    ["reports", companyGuid],
    COMPANY_REPORTS_QUERY,
    [{ companyGuid }],
    options,
  );

  return { ...result, data: result.data?.companyReports?.reports };
}
